import { filter } from 'lodash';
import { itemSchedulingFilterByTab } from '../../_lib/lib';
import { IItemSchedulingTab, ITabStats } from '../../types/IItemSetup';

const countedTabs = [
  IItemSchedulingTab.draft,
  IItemSchedulingTab.scheduled,
  IItemSchedulingTab.offering,
  IItemSchedulingTab.shipping,
  IItemSchedulingTab.negotiating,
  IItemSchedulingTab.finalizing,
] as const;

export const getItemSchedulingTabStats = (items?: any[] | null): ITabStats => {
  const stats: ITabStats = {
    [IItemSchedulingTab.draft]: 0,
    [IItemSchedulingTab.scheduled]: 0,
    [IItemSchedulingTab.offering]: 0,
    [IItemSchedulingTab.shipping]: 0,
    [IItemSchedulingTab.negotiating]: 0,
    [IItemSchedulingTab.finalizing]: 0,
  };
  items?.forEach((item: any) => {
    countedTabs.forEach((tab) => {
      if (itemSchedulingFilterByTab(tab, item)) stats[tab] += 1;
    });
  });
  return stats;
};

export const attachSecondItemGroup = (items: any[]) =>
  items.map((item: any) => ({
    ...item,
    secondItemGroup: filter(items, {
      itemNumber: item.itemNumber,
      color: item.color,
      groupName: item.groupName,
    }),
  }));
